<template>
  <div
    class="inline-flex rounded-md bg-slate-900 p-0.5"
    role="group"
    :aria-label="t('nav.language')"
  >
    <button
      v-for="option in SUPPORTED_LOCALES"
      :key="option"
      type="button"
      :data-testid="`${testIdPrefix}-${option}`"
      :class="[
        'rounded px-2 py-0.5 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400',
        locale === option
          ? 'bg-slate-600 text-white shadow-sm'
          : 'text-gray-300 hover:text-white',
        { 'tap-target': enlargedTapTarget },
      ]"
      :aria-pressed="locale === option"
      :aria-label="t(`locale.${option}`)"
      :lang="option"
      @click="setLocale(option)"
    >
      {{ option.toUpperCase() }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { SUPPORTED_LOCALES, useI18n } from "../i18n";

defineProps<{
  testIdPrefix: string;
  enlargedTapTarget?: boolean;
}>();

const { t, locale, setLocale } = useI18n();
</script>
